import { TemperatureCalibrationOutputByIdOutput } from './temperature-calibration-output-by-id-output.model';


export class TemperatureCalibrationSelectByIdOutput implements ITemperatureCalibrationSelectByIdOutput {
    status!: number;
    message!: string;
    data!: TemperatureCalibrationOutputByIdOutput;

    constructor(data?: ITemperatureCalibrationSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? TemperatureCalibrationOutputByIdOutput.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TemperatureCalibrationSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new TemperatureCalibrationSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ITemperatureCalibrationSelectByIdOutput {
    status: number;
    message: string;
    data: TemperatureCalibrationOutputByIdOutput;
}

